import { useState } from "react";
import { toast } from "sonner";
import { Check, ChevronDown, Loader2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { STAGES, stageOf } from "@/lib/mixDeskApi";
import { updateProject } from "@/lib/studioApi";
import { safeApiError } from "@/lib/safeErrorText";

/** Where the song is at — Idea · Writing · Recording · Mixing · Finished. */
export default function StagePicker({ project, onChanged }) {
  const [busy, setBusy] = useState(false);
  const current = stageOf(project.stage);
  const pick = async (key) => {
    setBusy(true);
    try { const p = await updateProject(project.id, { stage: key }); onChanged?.(p); toast.success(`Marked as ${stageOf(key).label}`); }
    catch (e) { toast.error("Couldn't change the status", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={`stage-picker-${project.id}`} data-stage={project.stage || ""} disabled={busy}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider transition-colors duration-200 ${current ? current.tone : "border-dashed border-white/20 text-white/50 hover:text-white"}`}>
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : null}{current ? current.label : "Set status"} <ChevronDown className="h-3 w-3 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="border-white/10 bg-[#0a0d1c] text-white">
        {STAGES.map((s) => (
          <DropdownMenuItem key={s.key} data-testid={`stage-option-${s.key}`} onSelect={() => pick(s.key)} className="flex items-center justify-between gap-6 text-[13px] focus:bg-white/[0.08] focus:text-white">
            {s.label} {project.stage === s.key ? <Check className="h-3.5 w-3.5 text-emerald-300" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
